export interface Category {
  id: number;
  name: string;
}

/** 「その他」カテゴリのID。APIマイグレーションの Category::OTHER_ID と一致させる。 */
export const OTHER_CATEGORY_ID = 18;
